import React from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoardingServiceItem, ServicesSectionConfig } from './types';
import PriceField from 'components/UI/V3/Forms/PriceField';
import { MobileDeleteButton } from '../MobileDeleteButton';
import styles from './ServiceRow.module.scss';

interface ServiceRowProps {
    service: BoardingServiceItem;
    onChange: (service: BoardingServiceItem) => void;
    onRemove: (serviceId: string) => void;
    config: ServicesSectionConfig;
}

export const ServiceRow: React.FC<ServiceRowProps> = ({ service, onChange, onRemove, config }) => {
    const handleNewRateChange = (value: number | undefined) => {
        onChange({ ...service, newRate: value || 0 });
    };

    const formatCurrency = (amount: number) => `$${amount.toFixed(2)}`;

    return (
        <div className={styles.container}>
            <div className={styles.mobileHeader}>
                <div className={styles.mobileServiceInfo}>
                    <p className={styles.serviceName}>{service.serviceName}</p>
                    <div className={styles.standardRate}>
                        <span className={styles.standardRateLabel}>{config.mobileRateLabel}</span>{' '}
                        {service.standardRate > 0 ? `${formatCurrency(service.standardRate)}/Night` : '-'}
                    </div>
                </div>
                <MobileDeleteButton
                    onClick={() => onRemove(service.id)}
                    title="Remove service"
                />
            </div>

            <button
                type="button"
                className={styles.deleteButton}
                onClick={() => onRemove(service.id)}
                title="Remove service"
            >
                <FontAwesomeIcon icon={faTimes} />
            </button>

            <div className={styles.row}>
                <div className={styles.cell}>
                    <p className={styles.serviceName}>{service.serviceName}</p>
                </div>

                <div className={styles.cell}>
                    <span className={styles.standardRate}>
                        {service.standardRate > 0 ? `${formatCurrency(service.standardRate)}/Night` : '-'}
                    </span>
                </div>

                {config.showNewRateColumn && (
                    <div className={styles.cell}>
                        <div className={styles.newRateLabel}>New Rate</div>
                        <div className={styles.priceInputContainer}>
                            <PriceField
                                scale={2}
                                value={
                                    service.newRate !== undefined && service.newRate > 0 ? service.newRate : undefined
                                }
                                onChange={handleNewRateChange}
                                placeholder="0.00"
                                className={styles.rateInput}
                            />
                            <span className={styles.priceUnit}>Night</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
